<template>
    <div>
        <headful
			title="Caseen - Classrooms"
		/>
        <md-tabs md-sync-route>
            <md-tab md-label="Joined Classrooms" to="/classrooms/" exact>
                <ClassroomTable :classroomData="joinedClassrooms"/>
            </md-tab>
            <md-tab md-label="Edit Classrooms" to="/classrooms/editor" v-if="$store.state.jwtClaims.isPremium">
                <md-button @click="createClassroom()" class="md-primary md-raised">
                    Create New Classroom
                </md-button>
                <ClassroomTable :classroomData="editableClassrooms" editorMode/>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>

    import APIRequests from "../APIRequests.js"
    import ClassroomTable from "./ClassroomTable.vue"
    export default {
        components: {
            ClassroomTable,
        },
        data: function(){
            return {
                joinedClassrooms: [],
                editableClassrooms: [],
                creatingClassroom: false,
            }
        },
        methods: {
            getJoinedClassrooms: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/joined"
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data = []
                    this.joinedClassrooms = data
                })
            },
            getEditableClassrooms: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/editable"
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data = []
                    this.editableClassrooms = data
                })
            },
            createClassroom: function(){
                if(!this.creatingClassroom){
                    if(!confirm("Start creating a new classroom?")){
                        return
                    }
                    this.creatingClassroom = true
                    var api_url = this.$store.state.api_url + "/api/classrooms/create";
                    APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                        this.$router.push("/classroom/" + data.id)
                    }).catch(() => {
                        alert("Error creating new classroom.")
                        this.creatingClassroom = false
                    })
                }
            },
        },
        mounted: function(){
            this.$nextTick(function () {
                this.getJoinedClassrooms().then(() => {
                    return this.getEditableClassrooms()
                }).catch(()=>{
                    this.$router.replace("/")
                })
            })
        }
    }
</script>

<style scoped>
    .md-tabs >>> .md-tabs-navigation {
        border-bottom: 2px solid #448aff;
    }
</style>
